import { useState, useEffect, useContext } from "react";
import { Store } from "@store";
import dynamic from "next/dynamic";
import axios from "axios";
import { getUserFeeds } from "@queries/user.queries";
import RenderPosts from "@components/post/FeedsItems";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "@components/loadings/LoadingCircle";
import { FEED_TYPES, VIEWTYPES } from "@utils/constants";
import { printInConsole } from "@utils/devtools/utils";
const NoPostComponent = dynamic(() => import("./NoPost"), {
  ssr: false
});
export default function CommunityProfileFeeds({
  profileUid,
  postType
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [noPost, setNoPost] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    async function getData(token) {
      setIsLoading(true);
      const response = await getUserFeeds({
        profileUid,
        postType: postType,
        accessToken: loggedInUser.accessToken,
        cancelToken: token
      }).catch(err => printInConsole(err.message));

      //printInConsole("Posts => ", response);

      if (response) {
        if (response.length === 0) {
          setPosts([]);
          setNoPost(true);
          setHasMore(false);
        } else {
          setPosts(response);
        }
      } else {
        setNoPost(true);
        setHasMore(false);
      }
      setIsLoading(false);
    }
    const source = axios.CancelToken.source();
    getData(source.token);
    return () => {
      if (source.cancel) source.cancel();
    };
  }, [profileUid, postType, loggedInUser]);
  async function updateData() {
    if (!hasMore) {
      return () => {};
    }
    const ts = posts[posts.length - 1]?.feedPostModel?.ts;
    const response = await getUserFeeds({
      profileUid,
      postType: postType,
      ts: ts,
      accessToken: loggedInUser.accessToken
    }).catch(err => printInConsole(err.message));
    if (response) {
      if (response.length === 0) {
        setHasMore(false);
      } else {
        setPosts(cur => cur.concat(response));
      }
    } else setHasMore(false);
  }
  function deletePostLocally(id) {
    const viewType = postType === FEED_TYPES.VIDEO ? VIEWTYPES.CLIPS_PROFILE : VIEWTYPES.POST;
    const array = posts.filter(item => {
      if (item.viewType === viewType) {
        if (item.response.feedID !== id) return item;else return null;
      } else {
        return item;
      }
    });
    if (array.length === 0) {
      setNoPost(true);
    }
    setPosts([...array]);
  }
  if (isLoading) {
    return <LoadingCircle />;
  }
  if (posts?.length > 0) {
    return <div>
        <InfiniteScroll dataLength={posts.length} next={updateData} hasMore={hasMore} loader={<LoadingCircle />}>
          <RenderPosts data={posts} clips={false} functions={{
          deletePostLocally
        }} />
        </InfiniteScroll>
      </div>;
  } else if (noPost) {
    return <NoPostComponent message={postType === FEED_TYPES.VIDEO ? "no clips yet" : "no posts yet"} />;
  } else return "";
}